<div class="modal-header">
  <h5 *ngIf="type == LeadType.Pv" class="modal-title lateral__bar blue" id="exampleModalLabel">Lead PV</h5>
  <h5 *ngIf="type == LeadType.Reclamacion" class="modal-title lateral__bar red" id="exampleModalLabel">Reclamación</h5>
  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
</div>
<form [formGroup]="dataformMessage">
  <div class="modal-body py-0 px-2">
    <div class="bg-grey p-3">
      <h4 class="mb-4 pb-3 border-bottom">Nueva acción</h4>
      <div *ngIf="leadsStatusData && (idSource !== 1 && idSource !== 3)" class="mb-4">
        <label>Estatus</label><br>
        <select2 [value]="newStatusLead.toString()" (update)="getStatus($event)" [data]="leadsStatusData" [multiple]="false">
        </select2>
      </div>

      <div *ngIf="(idSource == 1 || idSource == 3) && !idMessage" class="row align-items-start mb-2">
        <div class="col-lg-4 col-md-2">
          <label class="mb-2">Resultado del Contacto</label>
          <div class="form-check">
            <input class="form-check-input" type="radio" formControlName="RadioResultado" value="Realizado">
            <label class="form-check-label" for="flexRadioRealizado">
              Realizado
            </label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="radio" formControlName="RadioResultado" value="No realizado">
            <label class="form-check-label" for="flexRadioNoRealizado">
              No Realizado
            </label>
          </div>
        </div>

        <div class="col-lg-4 col-md-2">
          <label class="mb-2">Situación</label>
          <div *ngIf="dataformMessage.get('RadioResultado').value == 'Realizado'">
            <div class="form-check">
              <input class="form-check-input" type="radio" formControlName="RadioSituacion1" value="Cliente interesado">
              <label class="form-check-label" for="flexRadioClienteInteresado">
                Cliente interesado
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="radio" formControlName="RadioSituacion1" value="Cliente no interesado">
              <label class="form-check-label" for="flexRadioClienteNoInteresado">
                Cliente no interesado
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="radio" formControlName="RadioSituacion1" value="Cliente no contesta">
              <label class="form-check-label" for="flexRadioClienteNoContesta">
                Cliente no contesta
              </label>
            </div>
          </div>

          <div *ngIf="dataformMessage.get('RadioResultado').value !== 'Realizado'">
            <div class="form-check">
              <input class="form-check-input" type="radio" formControlName="RadioSituacion2" value="Email incorrecto">
              <label class="form-check-label" for="flexRadioClienteInteresado">
                Email / tel incorrecto
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="radio" formControlName="RadioSituacion2" value="Pendiente contactar">
              <label class="form-check-label" for="flexRadioClienteNoInteresado">
                Pendiente contactar
              </label>
            </div>
          </div>
        </div>


      </div>
      <div class="w-100 mb-2">
        <label>Mensaje*</label>
        <textarea formControlName="Message" type="text" class="form-control" placeholder="Título" [ngClass]="{'is-invalid':dataformMessage.get('Message').invalid && (!dataformMessage.get('Message').pristine || submitted == 1) , 'is-valid':dataformMessage.get('Message').valid && !dataformMessage.get('Message').pristine}" rows="4"></textarea>
        <div class="form-help">Es obligatorio introducir un mensaje.</div>
        <div class="invalid-feedback">
          <div [hidden]="!dataformMessage.controls['Message'].errors || !dataformMessage.controls['Message'].errors['required']">
            Mensaje requerido.
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="container">
      <div class="row text-end mb-2">
        <div class="col-12">
          <div class="form-help">* Es obligatorio cumplimentar los campos marcados con un asterisco.</div>
        </div>
      </div>
      <div class="row text-end">
        <div class="col-12">
          <button type="button" class="btn-line-primary me-2" data-bs-dismiss="modal" (click)="closeModal()">Cancelar</button>
          <button class="btn-yw" (click)="postMessage()">enviar</button>
        </div>
      </div>
    </div>
  </div>
</form>


<!-- MODAL EXAMPLE HTML
<div class="modal-content">
    <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Modal title</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    </div>
    <div class="modal-body">
        ...
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary">Save changes</button>
    </div>
</div>-->


<!-- OLD

    <div class="row">
     <div *ngIf="type == LeadType.Pv" class="col-8">
        <h1>Nueva Acción de Lead PV</h1>
        <h2></h2>
      </div>
      <div *ngIf="type == LeadType.Reclamacion" class="col-8">
        <h1>Nueva Acción de Reclamación</h1>
        <h2></h2>
      </div>

    <div class="col-md-12">
        <div *ngIf="leadsStatusData" class="col-lg-3 mb-4">
            <select2 [value]="lead.IdStatus" (update)="getStatus($event)" [data]="leadsStatusData" [multiple]="false">
            </select2>
        </div>
    </div>
    <div class="col-md-4">
        <button (click)="closeModal()">cerrar</button>
    </div>
</div>
<form [formGroup]="dataformMessage">
    <div class="row pt-4 clearfix">
        <div class="col-md-4">
            <div class="form-floating">
                <input formControlName="Message" type="text" class="form-control" placeholder="Título"
                    [ngClass]="{'is-invalid':dataformMessage.get('Message').invalid && (!dataformMessage.get('Message').pristine || submitted == 1) , 'is-valid':dataformMessage.get('Message').valid && !dataformMessage.get('Message').pristine}">
                <label>Mensaje</label>
                <div class="invalid-feedback">
                    <div
                        [hidden]="!dataformMessage.controls['Message'].errors || !dataformMessage.controls['Message'].errors['required']">
                        Mensaje requerido.
                    </div>

                </div>
            </div>
        </div>
    </div>
</form>
<button (click)="postMessage()">enviar</button> -->